export default "__VITE_ASSET__BzwLTS91__"